import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Stack from 'components/Stack';
import Button from 'components/Button';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';

import AuthPageWrapper from './shared/AuthPageWrapper';

function PasswordLinkExpired() {
	const [t] = useTranslation();
	return (
		<AuthPageWrapper>
			<ModalHeadline title={t('forgot_pw_expired_title')} />
			<Panel>
				<p>{t('forgot_pw_expired_description')}</p>
			</Panel>
			<Panel align="center">
				<Stack spacing="xs">
					<Button as={Link} to="/forgot" variant="primary">
						{t('forgot_pw_request_new_link')}
					</Button>
					<Button
						as={Link}
						to="login"
						size="medium"
						variant="transparent"
					>
						{t('back_to_login')}
					</Button>
				</Stack>
			</Panel>
		</AuthPageWrapper>
	);
}

export default PasswordLinkExpired;
